import React from 'react'
import Link from 'gatsby-link'
import missed from '../images/missed.gif';

const NotFoundPage = ({ data , transition }) => (
  <div style={transition && transition.style}>
    <h1>Near Miss. That Page Doesn't Exist</h1>
    <img src={missed} alt="near miss" className='headshot'/>
    <p>You just hit a route that doesn&#39;t exist... sorry about that.</p>
    <div className="home_write_list">
      <h2>Maybe you are looking for a recent post?</h2>
      <ul>
        {data.allMarkdownRemark.edges.map(post => (
          <li key={post.node.id}><Link to={post.node.frontmatter.path}>{post.node.frontmatter.title}</Link></li>
        ))}
      </ul>
    </div>
    
  </div>
  
)

export const pageQuery = graphql`
  query notFoundQuery {
    allMarkdownRemark(
      limit: 10
      sort: {fields: [frontmatter___date], order: DESC }
      filter: {frontmatter: {pub: {eq: true}} }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            path
            author
          }
        }
      }
    }
  }
`

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/404.js